module.exports = __webpack_public_path__ + "media/images/whatsapp_white-e2fef32059f10015f547381da687ec6a.png";